module.exports = __webpack_public_path__ + "static/media/schedule.1b8703e8.jpg";